import UI from './utils/UI'

setTimeout(() => {
	UI({
		component: '.js-singleRecipe',
		schema: '.js-singleRecipe-schema'
	}, () => {
		const schema = document.querySelector('.js-singleRecipe-schema');
		if (!schema) return
		const schemaObject = JSON.parse(schema.innerHTML)
		window.dataLayer = window.dataLayer || []
		window.dataLayer.push({ ...schemaObject, recipeName: schemaObject.name, event: 'recipeViewed' })
	})	
}, 10);


